import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clearErrors as reduxClearErrors, setError as reduxSetError, setSuccess as reduxSetSuccess, removeAlert as reduxRemoveAlert, removeAlertFromMessage as reduxRemoveAlertFromMessage } from '../redux/actions/alertActions';

export function useAlerts() {
  const dispatch = useDispatch();

  const clearErrors = useCallback(() => dispatch(reduxClearErrors()), [dispatch]);
  const setError = useCallback((...props) => reduxSetError(dispatch, ...props), [dispatch]);
  const setSuccess = useCallback((...props) => reduxSetSuccess(dispatch, ...props), [dispatch]);
  const removeAlert = useCallback((...props) => dispatch(reduxRemoveAlert(...props)), [dispatch]);
  const removeAlertFromMessage = useCallback((...props) => dispatch(reduxRemoveAlertFromMessage(...props)), [dispatch]);

  return { clearErrors, setError, setSuccess, removeAlert, removeAlertFromMessage };
}